<template>
    <div class="flex flex-wrap">
        <div
            v-if="motor && bike.electric == 'Y'"
            class="flex flex-wrap text-center md:flex-nowrap w-full mt-4"
        >
            <div class="aspect-[1.777] w-full md:w-2/5">
                <img
                    class="remove_bg_color pr-4"
                    :src="`/storage/assets/images/motors-description/${
                        motor.image || 'default.png'
                    }`"
                    alt=""
                />
            </div>
            <div class="w-full md:w-3/5">
                <h3 class="text-xl font-bold text-red">{{ motor.name }}</h3>
                <p class="mt-4 pr-4" v-html="motor.description"></p>
            </div>
        </div>

        <div
            v-if="battery && bike.electric == 'Y'"
            class="flex flex-wrap md:flex-nowrap w-full mt-4"
        >
            <div class="w-full md:w-3/5 text-center !md:text-left">
                <h3 class="text-xl font-bold text-red">{{ battery.name }}</h3>
                <p class="mt-4 pr-4" v-html="battery.description"></p>
                <p v-html="battery.link"></p>
            </div>
            <div class="aspect-[1.777] w-full md:w-2/5 pl-4">
                <img
                    :src="`/storage/assets/images/motors-description/${
                        battery.image || 'default.png'
                    }`"
                    class="remove_bg_color"
                    alt=""
                />
            </div>
        </div>
        <div
            v-if="displayDevice && bike.electric == 'Y'"
            class="flex flex-wrap text-center md:flex-nowrap w-full mt-4"
        >
            <div class="aspect-[1.777] w-full md:w-2/5 pr-4">
                <img
                    class="remove_bg_color"
                    :src="`/storage/assets/images/motors-description/${
                        displayDevice.image || 'default.png'
                    }`"
                    alt=""
                />
            </div>
            <div class="w-full md:w-3/5">
                <h3 class="text-xl font-bold text-red">
                    {{ displayDevice.name }}
                </h3>
                <p class="mt-4 pr-4" v-html="displayDevice.description"></p>
            </div>
        </div>
    </div>
</template>
<script setup>
import { defineProps, ref } from 'vue';

const props = defineProps({
    bike: Object,
});

import bikesBatteriesJson from '@/js/json/batteries.json';
import BikesDisplayDevicesJson from '@/js/json/displayDevices.json';
import bikesMotorsJson from '@/js/json/motors.json';

const displayDevice = ref();
const motor = ref();
const battery = ref();

const getMotor = motorName => {
    if (!motorName) return '';

    const motor = bikesMotorsJson.find(motor => motor.name === motorName);

    return motor;
};
const getBattery = batteryName => {
    if (!batteryName) return '';

    const battery = bikesBatteriesJson.find(
        battery => battery.name === batteryName,
    );

    return battery;
};
const getDisplayDevices = displayDeviceName => {
    if (!displayDeviceName) return '';

    const displayDevice = BikesDisplayDevicesJson.find(
        displayDevice => displayDevice.name === displayDeviceName,
    );

    return displayDevice;
};

motor.value = getMotor(props.bike.motor);
battery.value = getBattery(props.bike.battery);
displayDevice.value = getDisplayDevices(props.bike.display_device);
</script>
